const initialState = {
    auth : null,

    // current page access
    access : null,
}

const authReducer = (state = initialState, action) => {
    switch(action.type){
        case 'SET_AUTH':
            return {...state, auth : action.auth}
        case 'SET_ACCESS' :
            return {...state, access : action.access}
        default :
            return state;
    }
}

export default authReducer;